import Vue from "vue";
import Vuex from "vuex";
// import axios from "axios";
// import enurl from "@/api/environment";
Vue.use(Vuex);

export default new Vuex.Store({

});
